import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { Submotive4DataProps } from './props';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { ParamWithNestedParent } from '../../../../../../shared/types/param';
import {
    asyncGetLastCodeSuffixParam,
    asyncGetParams,
} from '../../../../../../services/param.service';
import { useParams } from 'react-router-dom';

export const useSubmotive4Data = ({
    data,
    onChangeData,
    onChangeFormik,
}: Submotive4DataProps) => {
    const typePQR = (
        (((data?.parent as ISelect)?.parent as ISelect)?.parent as ISelect)
            ?.parent as ISelect
    )?.parent as ISelect;
    const motive = (
        ((data?.parent as ISelect)?.parent as ISelect)?.parent as ISelect
    )?.parent as ISelect;
    const submotive1 = ((data?.parent as ISelect)?.parent as ISelect)
        ?.parent as ISelect;
    const submotive2 = (data?.parent as ISelect)?.parent as ISelect;
    const submotive3 = data?.parent as ISelect;

    const [newCode, setNewCode] = useState<string>('');
    const [types, setTypes] = useState<ISelect[]>([]);
    const [motives, setMotives] = useState<ISelect[]>([]);
    const [submotives1, setSubmotives1] = useState<ISelect[]>([]);
    const [submotives2, setSubmotives2] = useState<ISelect[]>([]);
    const [submotives3, setSubmotives3] = useState<ISelect[]>([]);

    const { idSubmotive4 } = useParams();
    const onSubmit = (data: ParamWithNestedParent) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(idSubmotive4),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('code', data?.code || newCode);
        formik?.setFieldValue('class', data?.class || ParamEnum.PQR_SUBMOTIVE4);
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active ?? true);
        formik?.setFieldValue('extra2', data?.extra2 || '');
        formik?.setFieldValue('parent', submotive3?.id || '');
        formik?.setFieldValue('nestedParent', submotive2?.id || '');
        formik?.setFieldValue('nestedParent2', submotive1?.id || '');
        formik?.setFieldValue('nestedParent3', motive?.id || '');
        formik?.setFieldValue('nestedParent4', typePQR?.id || '');
    }, [data, newCode]);

    useEffect(() => {
        asyncGetLastCodeSuffixParam(ParamEnum.PQR_SUBMOTIVE4).then(
            (res: any) => {
                setNewCode(res?.items);
            }
        );
    }, [newCode]);

    useEffect(() => {
        if (Boolean(formik.values.nestedParent4)) {
            asyncGetParams(
                ParamEnum.PQR_MOTIVE,
                undefined,
                formik.values.nestedParent4
            ).then((items) => {
                setMotives(items);
            });
        }
        if (!data || !Boolean(typePQR)) {
            formik?.setFieldValue('nestedParent3', '');
        }
        setSubmotives1([]);
        setSubmotives2([]);
        setSubmotives3([]);
        setMotives([]);
    }, [formik.values.nestedParent4, types]);

    useEffect(() => {
        if (Boolean(formik.values.nestedParent3)) {
            asyncGetParams(
                ParamEnum.PQR_SUBMOTIVE1,
                undefined,
                formik.values.nestedParent3
            ).then((items) => {
                setSubmotives1(items);
            });
        }
        if (!data || !Boolean(motive)) {
            formik?.setFieldValue('nestedParent2', '');
        }
        setSubmotives1([]);
        setSubmotives2([]);
        setSubmotives3([]);
    }, [formik.values.nestedParent3, motives]);

    useEffect(() => {
        if (Boolean(formik.values.nestedParent2)) {
            asyncGetParams(
                ParamEnum.PQR_SUBMOTIVE2,
                undefined,
                formik.values.nestedParent2
            ).then((items) => {
                setSubmotives2(items);
            });
        }
        if (!data || !Boolean(submotives1)) {
            formik?.setFieldValue('nestedParent', '');
        }
        setSubmotives2([]);
        setSubmotives3([]);
    }, [formik.values.nestedParent2, submotives1]);

    useEffect(() => {
        if (Boolean(formik.values.nestedParent)) {
            asyncGetParams(
                ParamEnum.PQR_SUBMOTIVE3,
                undefined,
                formik.values.nestedParent
            ).then((items) => {
                setSubmotives3(items);
            });
        }
        if (!data || !Boolean(submotive2)) {
            formik?.setFieldValue('parent', '');
        }
        setSubmotives3([]);
    }, [formik.values.nestedParent, submotives2]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_TYPE).then((items) => setTypes(items));
    }, []);

    return {
        formik,
        types,
        motives,
        submotives1,
        submotives2,
        submotives3,
    };
};
